import * as React from 'react';

export default function TextInput(props) {
    const {
        type='text',
        onChange=onChange,
        placeholder='',
        error='',
        style,
        value='',
        mainStyle
    } = props;

  return (
    <div style={{...styles.mainView,...mainStyle}}>
       <input value={value} type={type} onChange={({target})=>{
            onChange(target.value)
        }} placeholder={placeholder} style={{...styles.input,...style}} />
        <div>
          <p style={{marginBottom:10,marginTop:-13,marginLeft:18,color:'red',textAlign:'left'}}>{error}</p>
        </div>
    </div>
  );
}

const styles = {
  mainView:{
    paddingLeft: '16%',
    paddingRight: '16%',
    width: '100%',
    height:75,
    marginBottom:20
  },
  input:{
    fontFamily:'Montserrat',
    borderWidth:0,
    textAlign:'left',
    backgroundColor:'#CCDDFF',
    width:410,
    height:50,
    borderRadius:10,
    marginBottom:15,
    paddingLeft:20
  }
}